import POIParkingLotStateFields from "@/components/POI/POIStateFields/POIParkingLotStateFields/POIParkingLotStateFields.vue";
import POIStep from "@/components/POI/POIStep/POIStep.vue";

export default {
  components: { POIStep, POIParkingLotStateFields },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
